module.exports = __webpack_public_path__ + "img/bg-main.ae7a4799.webp";